// extracted by mini-css-extract-plugin
module.exports = {"PurchaseBackToTop":"PurchaseBackToTop_PurchaseBackToTop__oWz0U"};